// extracted by mini-css-extract-plugin
module.exports = {"invalidTabToken":"invalidTabToken__invalidTabToken___3ZUuY"};